import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
export function HTMLBlock({ data }) {
    return React.createElement(RawHTML, { html: data.value });
}
